import { ReactNode, useEffect, useState } from 'react'
import { Position, Rect, Transform } from 'types'
import useDragCss from './hooks/use-drag-css'
import useDragPosition from './hooks/use-drag-position'
import { Mover, Scaler } from './style'
import CropScaler from './types/scaler'

const ALL_SCALERS = CropScaler.all()

type Props = {
    aspectRatio?: number
    bounds: Rect
    children?: ReactNode
    className?: string
    crop: Position
    onDrag?: (position: Position) => void
    onDragEnd?: (position: Position) => void
}

const CropDraggable = ({ aspectRatio, bounds, children, className, crop, onDrag, onDragEnd }: Props) => {
    const [transform, setTransform] = useState<Transform | undefined>()
    const [persistDragState, setPersistDragState] = useState<boolean>(true)
    const [isDragging, setIsDragging] = useState<boolean>(false)
    const position = useDragPosition(crop, { aspectRatio, bounds, transform })
    const css = useDragCss(position)

    useEffect(() => {
        onDrag?.(position)
    }, [position])

    useEffect(() => {
        if (!isDragging) {
            onDragEnd?.(position)
            setTransform(undefined)
        }
    }, [isDragging])

    return (
        <div
            className={className}
            style={css}
            data-dragging={persistDragState || isDragging}
            onMouseOver={() => setPersistDragState(false)}
        >
            {children}
            <Mover onDragStateChange={setIsDragging} onMove={setTransform} />
            {ALL_SCALERS.map((type) => (
                <Scaler
                    controlType={`crop-${type}`}
                    crop={crop}
                    key={type}
                    lockAspectRatio={!!aspectRatio}
                    type={type}
                    onDragStateChange={setIsDragging}
                    onScale={setTransform}
                />
            ))}
        </div>
    )
}

export default CropDraggable
